import { Card, Col, Row, Typography } from 'antd'
import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { getDonorCardData, getDonorCounts } from '../../../../api';
import CountUp from 'react-countup';
import '../dash5.css'
import { NewColorTheme } from '../../../../appConst';

function DonorManagement() {
    const [cardData, setCardData] = useState(null)
    const [cardData2, setCardData2] = useState(null)
    const [shouldAnimate, setShouldAnimate] = useState(false);

    useEffect(() => {
        setShouldAnimate(true);
        loadData()

    }, [])

    const loadData = async () => {

        let agency
        let userLevel = await window.localStorage.getItem('ntfc_level')
        if (userLevel == 6 || userLevel == 7) {
            agency = 0
        } else {
            agency = window.localStorage.getItem('ntfc_agency')
        }
        getDonorCardData(agency).then((out) => {
            console.log("out--->>>", out.data.out)
            setCardData(out.data.out)

        });

        getDonorCounts().then((out) => {
            console.log("out2--->>>", out.data.out)
            setCardData2(out.data.out)

        });
    }

    return (
        <Card
            onClick={() => {
                window.location.href = "/donormanagement"

            }} className="custom-db-card enlarged-button2" style={{ background: "white", cursor: "pointer", borderRadius: "10px 0px 10px 10px" }}>
            <div className="custom-db-card-header" style={{ backgroundColor: NewColorTheme.dbCardHeader, borderRadius: "10px 0px 0px 0px" }}>
                <Typography className='custom-db-card-header-title' style={{ color: NewColorTheme.parimaryTitle }}>Donor management</Typography>

            </div>
            <div className='custom-db-card-body-donor' style={{ background: "white", borderRadius: "0px 0px 10px 10px" }} >
                <Row gutter={[16, 16]} style={{ width: "100%" }}>
                    <Col xs={24} lg={8}>
                        <div className='donor-main-count-div-five' onClick={(e) => {
                            e.stopPropagation()
                            window.location.href = "/donorprofile"
                        }}>
                            <span className='new-card-donor-new' style={{ color: NewColorTheme.parimaryTitle }}>
                                {shouldAnimate && <CountUp end={cardData && cardData.profiles ? cardData.profiles : 0} duration={2} />}

                            </span>
                            <span className="new-card-donor-title1" style={{ color: NewColorTheme.parimaryTitle }} >Donor</span>
                            <span className="new-card-donor-title2" style={{ color: NewColorTheme.parimaryTitle }} >Profiles</span>
                        </div>
                    </Col>
                    <Col xs={24} lg={16}>
                        <div>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'center'
                            }}>
                                <Row gutter={[8, 8]}>


                                    {localStorage.ntfc_level > 10 ?
                                        <Col xs={5}>
                                            <div className='donor-sub-count'>
                                                <span className='new-card-donor-req-count' style={{ color: NewColorTheme.parimaryTitle }}  >
                                                    {shouldAnimate && <CountUp end={cardData && cardData.requests ? cardData.requests : 0} duration={2} />}
                                                </span>
                                            </div>
                                        </Col>

                                        :
                                        <Col xs={10}>
                                            <div className='donor-sub-count'>
                                                <span className='new-card-donor-req-count' style={{ color: NewColorTheme.parimaryTitle }}  >
                                                    {shouldAnimate && <CountUp end={cardData2 && cardData2.my_donor_requests ? cardData2.my_donor_requests : 0} duration={2} />}
                                                </span>
                                            </div>
                                        </Col>

                                    }
                                    <Col xs={14} >
                                        <div style={{ display: 'flex', justifyContent: "end", alignItems: "center", height: "100%" }}>

                                            <span className='new-card-donor-req-content' style={{ color: NewColorTheme.parimaryTitle }} >Requests </span>
                                        </div>
                                    </Col>
                                    <Col xs={10}>
                                        <div className='donor-sub-count2'>
                                            <span className='new-card-donor-req-count' style={{ color: NewColorTheme.parimaryTitle }}  >
                                                {shouldAnimate && <CountUp end={cardData && cardData.interests ? cardData.interests : 0} duration={2} />}


                                            </span>
                                        </div>
                                    </Col>
                                    <Col xs={14} >
                                        <div style={{ display: 'flex', justifyContent: "end", alignItems: "center", height: "100%", marginTop: -14 }}>
                                            <span className='new-card-donor-req-content' style={{ color: NewColorTheme.parimaryTitle }}  >Interests</span>
                                        </div>
                                    </Col>



                                </Row>
                            </div>

                        </div>
                    </Col>

                </Row>
            </div>


        </Card>
    )
}

export default DonorManagement